import { render, staticRenderFns } from "./ListActivityLabourerWorkplacePage.vue?vue&type=template&id=18cffed8&"
import script from "./ListActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./ListActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports